import { GridColDef, GridColumnVisibilityModel } from "@mui/x-data-grid-pro";
import { GridMetaData, IColumnSetting } from "models/grids";
import { TeamTab } from "models/teams";
import { useCentralApi, useCurrentUser } from "hooks/shared";
import { toPascalCase } from "utils/string-utils";

const useTeamExport = (tab: TeamTab, gridMetadata: GridMetaData, columnVisibility: GridColumnVisibilityModel, columns: GridColDef[]) => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const fileName = `My Team - ${toPascalCase(tab)}`;
    
    const handleExport = async () => {
        let gridPreferences: IColumnSetting[] = [];
        for (var column in columnVisibility) {
            var position = columns.findIndex(f => f.field == column);
            gridPreferences.push({
                columnName: column,
                visible: columnVisibility[column],
                columnOrder: position,
            });
        }
        gridPreferences.sort((a, b) => (a.columnOrder || 0) - (b.columnOrder || 0));
        gridMetadata.gridPreferences = gridPreferences;

        console.log(columnVisibility);

        const resp = await fetcher(`/api/v3/teams/${tab}/export`, {
            method: 'POST',            
            body: JSON.stringify(gridMetadata)
        });

        const blob = new Blob([await resp.blob()], { type: "text/csv" });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    };

    return handleExport;
}

export default useTeamExport;